import React from 'react';
import PropTypes from 'prop-types';
import { PlusIcon } from '../../model/icons';

// Цветные вкладки команд (.tm-tabs) + кнопка добавления.
export default function TeamTabs({ teams, selectedTeam, onSelect, onAdd }) {
    return (
        <div className="tm-tabs">
            {teams.map(team => (
                <button
                    type="button"
                    key={team.id}
                    className={`tm-tab${selectedTeam === team.id ? ' on' : ''}`}
                    style={{ '--tc': team.color }}
                    onClick={() => onSelect(team.id)}
                >
                    <span className="dot" style={{ background: team.color }} />
                    {team.name || `Команда ${team.id}`}
                </button>
            ))}
            <button type="button" className="btn btn-primary tm-add" onClick={onAdd}>
                <span className="ic"><PlusIcon /></span>
                Добавить команду
            </button>
        </div>
    );
}

TeamTabs.propTypes = {
    teams: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string,
        color: PropTypes.string
    })).isRequired,
    selectedTeam: PropTypes.number,
    onSelect: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired
};

TeamTabs.defaultProps = { selectedTeam: null };
